module.exports = __webpack_public_path__ + "static/favicon-acc23cdcf0cd44bb42127d50fbf5c165.png";